module.exports = __webpack_public_path__ + "static/newmarket2-5c91f1c52bde53079a83063746a953c0.jpg";